export default __webpack_public_path__ + "assets/11479f08000d2db66d24237b913df73c.svg";